import React from "react";

export default function CSS_Certificate() {
  return (
    <div className="tutorial-page">
      <h1>CSS Certificate</h1>
      <p>This is the CSS Certificate tutorial page.</p>
    </div>
  );
}
